export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              51动漫移动端入口
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51动漫官网全面支持移动端访问，手机浏览器直接打开即可畅享高清动漫体验。无需下载额外应用，51动漫网与51动漫网站的移动版已针对小屏设备深度优化，触控操作流畅自如，随时随地追番看动漫。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              支持iOS与Android双平台，横竖屏自适应播放，流量模式下智能压缩画质，WiFi环境下自动切换高清。51动漫国产精品入口，指尖轻触即可直达。
            </p>
            <a
              href="#ranking"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-smartphone-line text-lg"></i>
              立即体验移动版
            </a>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[520px] rounded-3xl overflow-hidden bg-background-100 border-4 border-background-200 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylish%20mobile%20phone%20mockup%20displaying%20an%20anime%20streaming%20interface%20with%20colorful%20anime%20thumbnails%2C%20warm%20orange%20and%20red%20accent%20colors%2C%20modern%20UI%20design%2C%20clean%20layout%20with%20anime%20characters%2C%20vibrant%20visual%20style%2C%20dark%20mode%20with%20warm%20highlights%2C%20professional%20mockup%20presentation&width=520&height=1040&seq=app-mobile-anime&orientation=portrait"
                alt="51动漫移动端界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}